(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gv-promo-countdown"] && !Shopify.designMode) return;
  try {
    
  function initializeGautierPromotion(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const deadline = Date.parse(root.dataset.deadline);
    const offer = root.querySelector('[data-promo-offer]');
    const fallback = root.querySelector('[data-promo-fallback]');
    const days = root.querySelector('[data-promo-days]');
    const hours = root.querySelector('[data-promo-hours]');
    const minutes = root.querySelector('[data-promo-minutes]');
    const seconds = root.querySelector('[data-promo-seconds]');
    let timer;
    const update = () => {
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      if (!Number.isFinite(deadline) || remaining <= 0) {
        offer.hidden = true;
        fallback.hidden = false;
        if (timer) clearInterval(timer);
        return;
      }
      offer.hidden = false;
      fallback.hidden = true;
      days.textContent = String(Math.floor(remaining / 86400));
      hours.textContent = String(Math.floor(remaining % 86400 / 3600)).padStart(2, '0');
      minutes.textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
      seconds.textContent = String(remaining % 60).padStart(2, '0');
    };
    update();
    if (deadline > Date.now()) timer = setInterval(() => { if (!root.isConnected) { clearInterval(timer); return; } update(); }, 1000);
  }
  document.querySelectorAll('[data-gv-autumn-promo]').forEach(initializeGautierPromotion);
  document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-gv-autumn-promo]').forEach(initializeGautierPromotion); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
